<template>
  <div class="lad-filter--duration-content">
    <slot name="before-range" />

    <div class="wrapper-element-filter">
      <el-slider
        v-model="privateValues"
        range
        :show-tooltip="false"
        :min="min"
        :max="max"
      />
      <div class="wrapper-min-max-labels">
        <span class="value-min">{{
          $tc('filters.duration.days', firstValue, { days: firstValue })
        }}</span>
        <span class="value-max">{{
          $tc('filters.duration.days', lastValue, { days: lastValue })
        }}</span>
      </div>
    </div>

    <slot name="buttons" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadFilterDurationRange',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    value: { type: Array, default: [], required: true },
  },
  data() {
    return {
      privateValues: [],
    }
  },
  computed: {
    ...mapState('search', {
      searchValues: 'values',
    }),
    firstValue() {
      return Math.max(this.min, this.value[0] || this.min)
    },
    lastValue() {
      return Math.min(this.max, this.value[1] || this.max)
    },
    min() {
      return this.searchValues.duration.min
    },
    max() {
      return this.searchValues.duration.max
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.privateValues = newValue
      },
    },
    privateValues(newValue) {
      this.$emit('update-values', newValue)
    },
  },
}
</script>

<style lang="scss">
.lad-filter--duration-content {
  /** */
}
</style>
